

<div class="relative">
    <div class="w-full md:!sticky md:!top-0 md:bg-white md:z-[6]">
        <Filters />
    </div>
    <template v-if="!resultsStore.loading && resultsStore.pageInfo"> 
        <div class="flex flex-col xs:flex-row text-center xs:text-left justify-between items-center gap-half md:gap-1 p-half md:p-0.75 bg-primary-lightest md:hidden md:invisible">
            <ResultsHeader/>
        </div>
    </template>
    <div class="flex flex-col-reverse md:flex-row border-b-gray-500">
        <div class="md:grow ">
            <Results/>
            <template v-if="!resultsStore.loading"> 
                <Pagination/>
            </template>
        </div>
        <Map/>
    </div>
    <div
        v-if="resultsStore.loading"
        class="sticky h-lvh top-0 inset-0 w-full flex justify-center items-center text-center align-center bg-white bg-opacity-75 z-[999999]"
    >
    <div class="text-gray-500 p-2 text-center">
        <div class="p-qtr rounded-full shadow-lg flex mx-auto items-center  align-center justify-center bg-primary-lighter w-3 h-3 text-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-2 h-2 mx-auto stroke-primary animate-spin">
            <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
        </svg>
        </div>
      <br />
       <p class="text-sm text-primary block">loading items...</p>
    </div>
    </div>
</div>
